<template>
	<div>
		<div class="d-flex justify-space-between">
			<h2 class="mb-4">Training & Tutorial</h2>
		</div>
		<div>
			<v-text-field 
				v-model="search" 
				append-icon="mdi-magnify" 
				label="Search" 
				hide-details 
				solo 
				clearable
				@keyup="list"
				@click:clear="clearSearch"
			></v-text-field>
		</div>
		<v-card>
			<v-card v-for="(item, idxItem) in entityList" :key="idxItem" style="margin-top: 20px">
				<v-card-title>
					<strong>{{ item.heading }}</strong>
				</v-card-title>
				<v-card-text>
					<v-expansion-panels>
						<v-expansion-panel
							v-for="(data, idxData) in item.contentList"
							:key="idxData"
							color="white"
							style="border-style: solid; border-color: white"
						>
							<v-expansion-panel-header color="gr" style="padding: 0px">
								<v-row style="margin-top: 5px">
									<v-col cols="10">
										<span style="color: #0c3188 !important">
											<v-icon>mdi-circle-medium</v-icon>
											<strong>{{ data.title }}</strong>
										</span>
									</v-col>
								</v-row>
							</v-expansion-panel-header>
							<v-expansion-panel-content style="border-style: solid; border-color: #ded9d9; border-width: thin">
								<div style="margin-left: 10px; margin-top: 20px">
									<div><span v-html="data.descDisplay"></span></div>
									<div v-if="data.filename" style="margin-top: 5px">
										<v-btn
											style="background-color: lightblue; padding: 7px; border-radius: 10px"
											@click="openNewTab(data.filename)"
										>
											<v-icon color="red">mdi-file-pdf-box</v-icon>
											{{ data.title }}
										</v-btn>
									</div>
								</div>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-card-text>
			</v-card>
		</v-card>
	</div>
</template>

<script>
/* eslint-disable no-unused-vars */
import axios from "axios";

export default {
	data() {
		return {
			entityList: [],
			search: ""
		};
	},
	mounted: function () {
		this.list();
	},
	methods: {
		list() {
			axios.post("/system/trainingAndTutorial/list",{ keyword: this.search }).then((response) => {
				if (response.data) {
					this.entityList = response.data;
					this.setDesc();
				}
			});
		},
		setDesc() {
			for (let data of this.entityList) {
				for (let content of data.contentList) {
					let desc = content.desc
					desc = desc.replace(/\n/g, "</p><p>");
					desc = "<p>" + desc + "</p>";
					content.descDisplay = desc;
				}
			}
		},
		openNewTab(file) {
			window.open(file, "_blank");
		},	
		clearSearch() {
			this.search = "";
			this.list();
		},
	}
};
</script>
